import { render, staticRenderFns } from "./HistoryBookingDetail.vue?vue&type=template&id=dce94de0&lang=pug&"
import script from "./HistoryBookingDetail.vue?vue&type=script&lang=ts&"
export * from "./HistoryBookingDetail.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryBookingDetail.vue?vue&type=style&index=0&id=dce94de0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports